import React from 'react';

import { Fab, TableRow, ButtonBase, TableCell, TextField } from '@mui/material';

import AddIcon from '@mui/icons-material/Add';

import TrplSelect from '../../../../../common/TrplControls/TrplSelect';
import TrplCheckbox from '../../../../../common/TrplControls/TrplCheckbox';
import { connect } from 'react-redux';
import { getLinksSelectValues } from '../../../../../utils';

export default connect((state) => ({ jels: state.jels }))(({
  jels,
  group,
  classes,
  rowIndex,
  groupIndex,
  addGroupLink,
  openFrmEditModal,
  openTblEditModal,
  onGroupFieldChange,
}) => {
  const groupJelFalse = !group.link_jel || group.link_jel === 'none';
  const isAddLinkBtnDisabled = Boolean(!group.link_url && groupJelFalse);

  const linksSelectValues = getLinksSelectValues(jels);


  return (
    <TableRow
      style={{
        paddingLeft: '33px',
        boxSizing: 'border-box',
      }}
    >
      <TableCell className={classes.tCell} />
      <TableCell className={classes.tCell}>
        <TextField
          value={group.link_title || ''}
          className={`${classes.fw} ${classes.mr10}`}
          onChange={(e) => onGroupFieldChange(rowIndex, groupIndex, 'link_title', e.target.value)}
        />
      </TableCell>

      <TableCell className={classes.tCell}>
        <TextField
          value={group.link_url || ''}
          className={`${classes.fw} ${classes.mr10}`}
          disabled={Boolean(group.link_jel && group.link_jel !== 'none')}
          onChange={(e) => onGroupFieldChange(rowIndex, groupIndex, 'link_url', e.target.value)}
        />
      </TableCell>

      <TableCell className={classes.tCell} style={{ width: '112px' }}>
        <TrplCheckbox
          style={{ flexShrink: 0 }}
          checked={group.link_target}
          onChange={(e) => onGroupFieldChange(rowIndex, groupIndex, 'link_target', e.target.checked)}
        />
      </TableCell>

      <TableCell className={classes.tCell} style={{ width: '50px' }}/>

      <TableCell className={classes.tCell} style={{ width: '200px' }}>
        <TrplSelect
          margin="none"
          complicatedValues
          values={linksSelectValues}
          value={group.link_jel}
          placeholder='Select view'
          disabled={Boolean(group && group.link_url && !!group.link_url.length)}
          onChange={(e) => {
            onGroupFieldChange(rowIndex, groupIndex, 'link_jel', e.target.value);
          }}
          firstChilds={
            <React.Fragment>
              <ButtonBase
                style={{ textTransform: 'none' }}
                onClick={() => {
                  openFrmEditModal(rowIndex, groupIndex);
                }}
                className={`${classes.btnGray} ${classes.mb5}`}
              >
                Create form <AddIcon className={`btn-gray-icon ${classes.btnGrayIcon}`} />
              </ButtonBase>

              <ButtonBase
                style={{ textTransform: 'none' }}
                onClick={() => {
                  openTblEditModal(rowIndex, groupIndex);
                }}
                className={`${classes.btnGray} ${classes.mb5}`}
              >
                Create table <AddIcon className={`btn-gray-icon ${classes.btnGrayIcon}`} />
              </ButtonBase>
            </React.Fragment>
          }
        />
      </TableCell>

      <TableCell className={classes.tCell}>
        <Fab
          size="small"
          color="primary"
          variant="circular"
          disabled={isAddLinkBtnDisabled}
          onClick={() => addGroupLink(rowIndex, groupIndex)}
          style={{
            flexShrink: '0',
            zoom: '0.8',
          }}
        >
          <AddIcon />
        </Fab>
      </TableCell>
    </TableRow>
  );
});